import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { listOrganizationalUnits } from '../services/api_org_unit';
import { AuthContext } from '../contexts/auth';
import { Link } from 'wouter';
import Footer from '../components/footer';
import { PlusIcon } from '@heroicons/react/24/outline';
import Loader from '../components/loader';
import LoaderSvg from '../components/loader_svg';
import PopoverComponentCustom from '../components/popover_component';



const OrgUnit = ({ unitData, onAdd, onUpdate, onDelete }) => {
  return (
    <ul className="m-2 shadow-md rounded divide-y border divide-gray-100 p-4">
      <li className="bg-white m-4 flex flex-wrap border border-gray-300 shadow-md rounded items-center justify-between gap-x-6 gap-y-4 py-5 px-4 sm:flex-nowrap hover:bg-indigo-100">
        <div>
          <p className="text-sm font-semibold leading-6 text-gray-900">
              <Link to={`/organization/${unitData.id}`} className="hover:underline uppercase">{unitData.name}</Link>
          </p>
          <div className="mt-1 flex items-center gap-x-2 text-xs leading-5 text-gray-500">
            <p>
              <a href="#" className="hover:underline">{unitData.description}</a>
            </p>
          </div>
        </div>
        <dl className="flex w-full flex-none justify-between gap-x-8 sm:w-auto">
          <div className="flex -space-x-0.5">
            
          </div>
          <div className="flex w-16 gap-x-2.5">
            <dt title='Dipendenti'>
              <span className="sr-only">Dipendenti</span>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z" />
              </svg>
            </dt>
            <dd className="text-sm leading-6 text-gray-900">{unitData.resources}</dd>
          </div>
          <div className="flex w-16 gap-x-2.5">
            <dt title='Managers'>
              <span className="sr-only">Managers</span>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 3.75h.008v.008h-.008v-.008Zm0 3h.008v.008h-.008v-.008Zm0 3h.008v.008h-.008v-.008Z" />
              </svg>

            </dt>
            <dd className="text-sm leading-6 text-gray-900">{unitData.managers}</dd>
          </div>
          

        </dl>
      </li>
      
      {unitData.children && unitData.children.map((child) => (
          <OrgUnit key={child.id} unitData={child} onAdd={onAdd} onUpdate={onUpdate} onDelete={onDelete} />
      ))}
    </ul>
  );
};

const OrgTree = () => {
  const [units, setUnits] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  const { profile, token, setProfile } = useContext(AuthContext)
  const isProfileComplete = profile.has_complete_profile;

  useEffect(() => {
    const fetchUnits = async () => {
      setIsLoading(true);
      setIsError(false);

      try {
        const response = await listOrganizationalUnits(token, false, null, 'attendance');
        
        setUnits(response.data || []);
      } catch (error) {  
        console.error('Error fetching units:', error);
        if (error.response && error.response.status !== 402) {
          setIsError(true);
        }
      } finally {
        setIsLoading(false);
      }
    };

    fetchUnits();
  }, [token]);

  // const readUnits = async () => {
  //   const response = await axios.get(API_BASE_URL);
  //   return response.data; // Assuming the API returns the data in the desired format
  // };

  // if (isLoading) return <div>Loading...</div>;
  if (isError) return <div>Error loading data.</div>;

  return (
    <div>
      <PopoverComponentCustom title="Unità Organizzative" />

      {profile?.customer_type === 'company' && !isProfileComplete && profile?.company?.email == profile?.the_real_user_email && (
        <div className="w-full">
          <div className="bg-orange-100 text-orange-600 p-4 mb-6">
            <p className="text-center text-sm font-semibold">
              Il profilo non è completo. <br />
              Compila i campi mancanti{' '}
              <Link
                to="/profilo/fatturazione"
                className="text-indigo-600 hover:text-indigo-800 underline"
              >
                cliccando qui
              </Link>
            </p>
          </div>
        </div>
      )}
      
      {units?.length === 0 ? (
        <div className="m-8 rounded-lg border-2 border-dashed border-gray-300 p-6 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 text-sm font-semibold text-gray-900">
          <div className="text-center mt-8">
            {
              isLoading ? (
                <LoaderSvg show={true} textColor={''} svgColor={'fill-indigo-800'} />
              ) : <p>Non sono presenti Unità Organizzative</p>
            }
            
            <button className="bg-indigo-600 hover:bg-gray-200 text-white py-2 px-4 rounded mt-4">
              <Link href="/organization/new">
                <a className="flex items-center">
                  <PlusIcon className="inline-block h-5 w-5 me-1" />
                  Crea Nuova
                </a>
              </Link>
            </button>
          </div>
        </div>
      ) : (

        <>  
          <div className="text-right my-6 mr-8">
            <button className="bg-indigo-600 hover:bg-indigo-500 text-white py-2 px-4 rounded">
              <Link href="/organization/new">
                <a className="flex items-center font-semibold">
                  <PlusIcon className="inline-block h-5 w-5 me-1" />
                  Crea Unità Organizzativa
                </a>
              </Link>
            </button>
          </div>
     
          {units?.map((unit) => (
            <OrgUnit
              key={unit.id}
              unitData={unit}
              onAdd={undefined}
              onUpdate={undefined}
              onDelete={undefined}
            />
          ))}
        </>
      )}

      <div className="mt-8">
        <Footer />
      </div>
    </div>
  );
};

export { OrgTree }